import { Product } from "Context/context";
import { useContext } from "react";

export function useProduct() {
  return useContext(Product);
}
